import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d36d8916")

_pushScopeId("data-v-d36d8916")
const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "topbox" }
const _hoisted_3 = { class: "member clearfix" }
const _hoisted_4 = { class: "img fl" }
const _hoisted_5 = { class: "info fl" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "datainfo clearfix" }
const _hoisted_9 = { class: "fl" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 检测时长：")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" h ")
const _hoisted_12 = { class: "fr" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 有效数据：")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "title bgblue subpadding" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "t" }, "中医心藏功能态势测评报告", -1)
const _hoisted_18 = { class: "scorebox" }
const _hoisted_19 = { class: "score" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, "综合得分", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时心率分布图", -1)
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "title bgblue subpadding" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "t" }, "中医肝藏功能态势测评报告", -1)
const _hoisted_25 = { class: "scorebox" }
const _hoisted_26 = { class: "score" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, "综合得分", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时心率分布图", -1)
const _hoisted_29 = { class: "card" }
const _hoisted_30 = { class: "title bgblue subpadding" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "t" }, "中医肾藏功能态势测评报告", -1)
const _hoisted_32 = { class: "scorebox" }
const _hoisted_33 = { class: "score" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", null, "综合得分", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时体动分布图", -1)
const _hoisted_36 = { class: "skeletonbox" }
const _hoisted_37 = { class: "imeibox clearfix" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "version fl" }, "报告版本：V6.0", -1)
const _hoisted_39 = { class: "version fr" }
const _hoisted_40 = { class: "footer clearfix" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_ScoreNum = _resolveComponent("ScoreNum")
  const _component_ReportSubTitleItem = _resolveComponent("ReportSubTitleItem")
  const _component_van_skeleton = _resolveComponent("van-skeleton")
  const _component_PersonInfoToast = _resolveComponent("PersonInfoToast")
  const _component_Disclaimers = _resolveComponent("Disclaimers")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")

  return (_openBlock(), _createBlock(_component_van_pull_refresh, {
    modelValue: _ctx.loading,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = $event)),
    onRefresh: _ctx.onRefresh
  }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_van_image, {
                round: "",
                width: "1.45rem",
                height: "1.45rem",
                src: _ctx.memberData?.memberAvatar ?? _ctx.avatarDefault
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.memberData?.memberName ?? '-'), 1),
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.heartReportData?.reportDate?.substring(0, 10)) + " - " + _toDisplayString(_ctx.heartReportData?.createTime?.substring(0, 10)), 1)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              (_ctx.heartReportData?.examinetime.length < 5)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.heartReportData?.examinetime), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.heartReportData?.examinetime?.substring(0, 5)), 1)
                  ], 64)),
              _hoisted_11
            ]),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              (_ctx.heartReportData?.validation.length < 5)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.heartReportData?.validation), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.heartReportData?.validation?.substring(0, 5)), 1)
                  ], 64)),
              _hoisted_14
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_ScoreNum, {
                  score: parseInt(_ctx.heartReportData?.heartMultiScore)
                }, null, 8, ["score"])
              ]),
              _hoisted_20
            ])
          ]),
          _createVNode("img", {
            class: "chartimg",
            src: _ctx.heartReportData?.ecgCurveUrl,
            alt: "24小时心率分布图"
          }, null, 8, ["src"]),
          _hoisted_21
        ]),
        _createVNode(_component_ReportSubTitleItem, {
          data: _ctx.heartReportData?.detailList,
          codeList: _ctx.heartReportData?.codeList,
          pulseCurveUrl: _ctx.heartReportData?.pulseCurveUrl,
          poincareUrl: _ctx.heartReportData?.poincareUrl
        }, null, 8, ["data", "codeList", "pulseCurveUrl", "poincareUrl"]),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_ScoreNum, {
                  score: parseInt(_ctx.liverReportData?.liverMultiScore)
                }, null, 8, ["score"])
              ]),
              _hoisted_27
            ])
          ]),
          _createVNode("img", {
            class: "chartimg",
            src: _ctx.heartReportData?.ecgCurveUrl,
            alt: "24小时心率分布图"
          }, null, 8, ["src"]),
          _hoisted_28
        ]),
        _createVNode(_component_ReportSubTitleItem, {
          data: _ctx.liverReportData?.detailList,
          codeList: _ctx.liverReportData?.codeList,
          pulseCurveUrl: _ctx.heartReportData?.pulseCurveUrl
        }, null, 8, ["data", "codeList", "pulseCurveUrl"]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode(_component_ScoreNum, {
                  score: parseInt(_ctx.kidneyReportData?.kidneyMultiScore)
                }, null, 8, ["score"])
              ]),
              _hoisted_34
            ])
          ]),
          _createVNode("img", {
            class: "chartimg",
            src: _ctx.kidneyReportData?.pmCurveUrl,
            alt: "24小时体动分布图"
          }, null, 8, ["src"]),
          _hoisted_35,
          _createVNode(_component_ReportSubTitleItem, {
            data: _ctx.kidneyReportData?.detailList,
            codeList: _ctx.kidneyReportData?.codeList,
            ecgCurveUrl: _ctx.heartReportData?.ecgCurveUrl
          }, null, 8, ["data", "codeList", "ecgCurveUrl"])
        ])
      ], 512), [
        [_vShow, _ctx.heartReportData]
      ]),
      _withDirectives(_createVNode("div", _hoisted_36, [
        _createVNode(_component_van_skeleton, {
          title: "",
          avatar: "",
          row: 1
        }),
        _createVNode(_component_van_skeleton, {
          title: "",
          row: 5
        }),
        _createVNode(_component_van_skeleton, {
          title: "",
          row: 5
        })
      ], 512), [
        [_vShow, !_ctx.heartReportData]
      ]),
      _createVNode("div", _hoisted_37, [
        _hoisted_38,
        _createVNode("div", _hoisted_39, "设备编号：" + _toDisplayString(_ctx.heartReportData?.imei ?? '-'), 1)
      ]),
      _createVNode("div", _hoisted_40, [
        (_ctx.heartReportData?.expertId === '103')
          ? (_openBlock(), _createBlock(_component_PersonInfoToast, {
              key: 0,
              title: "健康报告专家授权：",
              person: "王义国"
            }))
          : (_openBlock(), _createBlock(_component_PersonInfoToast, {
              key: 1,
              title: "健康报告专家授权：",
              person: "张启明"
            }))
      ]),
      _createVNode(_component_Disclaimers, { padding: "0 0.4rem 0.4rem" })
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
})